module.exports = __webpack_public_path__ + "media/images/vglist-favicon-0e5fdbb4f1cf74e815664effc83bfe65.svg";